var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _c(
          "div",
          {
            staticClass: "breadcrumbs ace-save-state",
            attrs: { id: "breadcrumbs" }
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "gates" } } },
                  [_c("a", [_vm._v("ゲート一覧")])]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [_vm._v("ゲート編集")])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content detail-gate-edit" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.message_success
              ? _c("div", { staticClass: "alert alert-success" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.message_success) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.message_error
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.message_error) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "form",
                  { staticClass: "form-horizontal", attrs: { role: "form" } },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-6" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "profile-user-info profile-user-info-striped"
                            },
                            [
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲートID")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.gateId))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("製品ID")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.gateModelId))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("製品名")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "product_error" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.gateInfor.gateModelId,
                                            expression: "gateInfor.gateModelId"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          "data-placeholder": "製品名選択"
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.gateInfor,
                                                "gateModelId",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            function($event) {
                                              _vm.getGateModelInforWithGateModeId(
                                                _vm.gateInfor.gateModelId
                                              )
                                            }
                                          ]
                                        }
                                      },
                                      _vm._l(_vm.listGateModel, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: {
                                              value: item.gateModelId
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(item.gateModelName) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      })
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("型番")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.gateInfor.gateModelCode)
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("アイコンタイプ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.gateInfor.iconType,
                                            expression: "gateInfor.iconType"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "iconType",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(_vm.listIconType, function(item) {
                                        return _c(
                                          "option",
                                          {
                                            key: item.value,
                                            domProps: { value: item.value }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(item.text) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      })
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ターゲット動作設定")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.target))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ターゲット動作設定Time")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.controlTime,
                                          expression: "gateInfor.controlTime"
                                        }
                                      ],
                                      staticClass: "form-control input-sm",
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        max: "10000"
                                      },
                                      domProps: {
                                        value: _vm.gateInfor.controlTime
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.gateInfor,
                                            "controlTime",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲート名")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "gate_error" }
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.gateName,
                                          expression: "gateInfor.gateName"
                                        }
                                      ],
                                      staticClass: "form-control input-sm",
                                      attrs: { type: "text", id: "gatename" },
                                      domProps: {
                                        value: _vm.gateInfor.gateName
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.gateInfor,
                                            "gateName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲート動作モード")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.gateInfor.isVisitor,
                                            expression: "gateInfor.isVisitor"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "isVisitor",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(_vm.listIsVisitor, function(item) {
                                        return _c(
                                          "option",
                                          {
                                            key: item.value,
                                            domProps: { value: item.value }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(item.text) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      })
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("NFCの有効")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.isNFCValid,
                                          expression: "gateInfor.isNFCValid"
                                        }
                                      ],
                                      staticClass:
                                        "ace ace-switch ace-switch-4",
                                      attrs: {
                                        name: "switch-field-1",
                                        type: "checkbox"
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.gateInfor.isNFCValid
                                        )
                                          ? _vm._i(
                                              _vm.gateInfor.isNFCValid,
                                              null
                                            ) > -1
                                          : _vm.gateInfor.isNFCValid
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.gateInfor.isNFCValid,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.gateInfor.isNFCValid = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.gateInfor.isNFCValid = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "isNFCValid",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "lbl" })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("テンキーの有効・無効")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.isTenKeyValid,
                                          expression: "gateInfor.isTenKeyValid"
                                        }
                                      ],
                                      staticClass:
                                        "ace ace-switch ace-switch-4",
                                      attrs: {
                                        name: "switch-field-1",
                                        type: "checkbox"
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.gateInfor.isTenKeyValid
                                        )
                                          ? _vm._i(
                                              _vm.gateInfor.isTenKeyValid,
                                              null
                                            ) > -1
                                          : _vm.gateInfor.isTenKeyValid
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.gateInfor.isTenKeyValid,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.gateInfor.isTenKeyValid = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.gateInfor.isTenKeyValid = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "isTenKeyValid",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "lbl" })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲートパスワードの有効・無効")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.gateInfor.isGatePasswordValid,
                                          expression:
                                            "gateInfor.isGatePasswordValid"
                                        }
                                      ],
                                      staticClass:
                                        "ace ace-switch ace-switch-4",
                                      attrs: {
                                        name: "switch-field-1",
                                        type: "checkbox",
                                        disabled: _vm.gateInfor.isVisitor
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.gateInfor.isGatePasswordValid
                                        )
                                          ? _vm._i(
                                              _vm.gateInfor.isGatePasswordValid,
                                              null
                                            ) > -1
                                          : _vm.gateInfor.isGatePasswordValid
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a =
                                              _vm.gateInfor.isGatePasswordValid,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.gateInfor.isGatePasswordValid = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.gateInfor.isGatePasswordValid = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "isGatePasswordValid",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "lbl" })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲートパスワードの桁数")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.gateInfor.gatePasswordLength,
                                            expression:
                                              "gateInfor.gatePasswordLength"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          disabled: _vm.getEditStatus()
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "gatePasswordLength",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(_vm.listPassLenght, function(
                                        item
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: item.value,
                                            domProps: { value: item.value }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(item.text) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      })
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲートパスワードのseed値")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "passwordseed_error" }
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.gatePasswordSeed,
                                          expression:
                                            "gateInfor.gatePasswordSeed"
                                        }
                                      ],
                                      staticClass: "form-control input-sm",
                                      staticStyle: {
                                        "text-transform": "uppercase"
                                      },
                                      attrs: {
                                        type: "text",
                                        id: "pseed",
                                        disabled: _vm.getEditStatus()
                                      },
                                      domProps: {
                                        value: _vm.gateInfor.gatePasswordSeed
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.gateInfor,
                                            "gatePasswordSeed",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("2段階認証の有効・無効")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.gateInfor.isTwoStepAuthValid,
                                          expression:
                                            "gateInfor.isTwoStepAuthValid"
                                        }
                                      ],
                                      staticClass:
                                        "ace ace-switch ace-switch-4",
                                      attrs: {
                                        name: "switch-field-1",
                                        type: "checkbox",
                                        disabled: _vm.gateInfor.isVisitor
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.gateInfor.isTwoStepAuthValid
                                        )
                                          ? _vm._i(
                                              _vm.gateInfor.isTwoStepAuthValid,
                                              null
                                            ) > -1
                                          : _vm.gateInfor.isTwoStepAuthValid
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a =
                                              _vm.gateInfor.isTwoStepAuthValid,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.gateInfor.isTwoStepAuthValid = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.gateInfor.isTwoStepAuthValid = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "isTwoStepAuthValid",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "lbl" })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("BLE出力設定")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.gateInfor.bleIntensity,
                                            expression: "gateInfor.bleIntensity"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "bleIntensity",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(_vm.listBleIntensity, function(
                                        item
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: item.value,
                                            domProps: { value: item.value }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(item.text) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      })
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ブザー鳴動設定")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.gateInfor.buzzerPattern,
                                            expression:
                                              "gateInfor.buzzerPattern"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "buzzerPattern",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(_vm.listBuzzerPattern, function(
                                        item
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: item.value,
                                            domProps: { value: item.value }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(item.text) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      })
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-6" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "profile-user-info profile-user-info-striped"
                            },
                            [
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("備考.1")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "option1_error" }
                                    }),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.option1,
                                          expression: "gateInfor.option1"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "option1",
                                        placeholder: "備考.1"
                                      },
                                      domProps: {
                                        value: _vm.gateInfor.option1
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.gateInfor,
                                            "option1",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("備考.2")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "option2_error" }
                                    }),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.option2,
                                          expression: "gateInfor.option2"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "option1",
                                        placeholder: "備考.2"
                                      },
                                      domProps: {
                                        value: _vm.gateInfor.option2
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.gateInfor,
                                            "option2",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲート個体番号1")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.gateSNMain))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲート個体番号2")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.gateSNBLE))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [
                                    _vm._v(
                                      "適用されているファームウェアバージョン（メインボード）"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.gateFWMain))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [
                                    _vm._v(
                                      "適用されているファームウェアバージョン（BLE）"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.gateFWBLE))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("登録日")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.converDate(
                                            _vm.gateInfor.registered
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("設定更新日")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.converDate(_vm.gateInfor.updated)
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲートへ設定情報を適用した日時")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.converDate(_vm.gateInfor.reported)
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [
                                    _vm._v(
                                      "個人コード照合データー：最新リビジョン"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.gateInfor.revisionDesired)
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [
                                    _vm._v(
                                      "個人コード照合データー：ゲートへ設定済みのリビジョン"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.gateInfor.revisionReported)
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("電池電圧")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.voltage))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("電池電圧更新日")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.converDate(_vm.gateInfor.scanDate)
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ステータス")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.isValid,
                                          expression: "gateInfor.isValid"
                                        }
                                      ],
                                      staticClass:
                                        "ace ace-switch ace-switch-4",
                                      attrs: {
                                        name: "switch-field-1",
                                        type: "checkbox"
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.gateInfor.isValid
                                        )
                                          ? _vm._i(
                                              _vm.gateInfor.isValid,
                                              null
                                            ) > -1
                                          : _vm.gateInfor.isValid
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.gateInfor.isValid,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.gateInfor.isValid = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.gateInfor.isValid = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "isValid",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "lbl" })
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 text-align-right" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn cancel_bottom",
                              attrs: { to: { name: "gates" } }
                            },
                            [
                              _vm._v(
                                "\n                  キャンセル\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info save_group_bottom",
                              attrs: { type: "button" },
                              on: { click: _vm.validateBeforeSubmit }
                            },
                            [
                              _vm._v(
                                "\n                  保存\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "accordion-style1 panel-group",
                        attrs: { id: "accordion" }
                      },
                      [
                        _c("div", { staticClass: "panel panel-default" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "panel-collapse collapse",
                              attrs: {
                                id: "relation-gate",
                                "aria-expanded": "true"
                              }
                            },
                            [
                              _c("div", { staticClass: "panel-body" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-striped table-bordered table-hover dataTable",
                                    staticStyle: { "min-width": "100%" }
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _vm.listGateGroup != null
                                          ? _c(
                                              "th",
                                              {
                                                staticClass: "center",
                                                staticStyle: {
                                                  width: "50px!important"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "pos-rel" },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectAllGate,
                                                          expression:
                                                            "selectAllGate"
                                                        }
                                                      ],
                                                      staticClass: "ace",
                                                      attrs: {
                                                        type: "checkbox"
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.selectAllGate
                                                        )
                                                          ? _vm._i(
                                                              _vm.selectAllGate,
                                                              null
                                                            ) > -1
                                                          : _vm.selectAllGate
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.selectAllGate,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.selectAllGate = $$a.concat(
                                                                  [$$v]
                                                                ))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.selectAllGate = $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                            }
                                                          } else {
                                                            _vm.selectAllGate = $$c
                                                          }
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "lbl"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ゲートグループID")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ゲートグループ名")]),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "center" }, [
                                          _vm._v("ステータス")
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.listGateGroup != null
                                      ? _c(
                                          "tbody",
                                          [
                                            _vm._l(_vm.listGateGroup, function(
                                              item,
                                              index
                                            ) {
                                              return [
                                                _c(
                                                  "tr",
                                                  {
                                                    key: index,
                                                    class: {
                                                      selected: _vm.rowSelectedGate(
                                                        item.relationId
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "pos-rel"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.selectedGateId,
                                                                  expression:
                                                                    "selectedGateId"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "ace",
                                                              attrs: {
                                                                type: "checkbox"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.relationId,
                                                                checked: Array.isArray(
                                                                  _vm.selectedGateId
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.selectedGateId,
                                                                      item.relationId
                                                                    ) > -1
                                                                  : _vm.selectedGateId
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm.selectedGateId,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c = $$el.checked
                                                                      ? true
                                                                      : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v =
                                                                        item.relationId,
                                                                      $$i = _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        (_vm.selectedGateId = $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        (_vm.selectedGateId = $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                    }
                                                                  } else {
                                                                    _vm.selectedGateId = $$c
                                                                  }
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass: "lbl"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.groupId.groupId
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.groupId.name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        item.groupId.isValid
                                                          ? _c("span", [
                                                              _vm._v("有効")
                                                            ])
                                                          : _c("span", [
                                                              _vm._v("無効")
                                                            ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      : _c("tbody", [_vm._m(3)])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-cus btn-right btn-add",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.addGroup(_vm.gateInfor.gateId)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    ゲートグループの関連付けを追加\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn-cus btn-right btn-delete",
                                    attrs: {
                                      href: "#processGate",
                                      "data-toggle": "modal"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.resetStatus()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "チェックしたゲートグループの関連付け解除"
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "panel panel-default" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "panel-collapse collapse",
                              attrs: { id: "passage" }
                            },
                            [
                              _c("div", { staticClass: "panel-body" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-striped table-bordered table-hover dataTable",
                                    staticStyle: { "min-width": "100%" }
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _vm.listUserGroup != null
                                          ? _c(
                                              "th",
                                              {
                                                staticClass: "center",
                                                staticStyle: {
                                                  width: "50px!important"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "pos-rel" },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectAllUser,
                                                          expression:
                                                            "selectAllUser"
                                                        }
                                                      ],
                                                      staticClass: "ace",
                                                      attrs: {
                                                        type: "checkbox"
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.selectAllUser
                                                        )
                                                          ? _vm._i(
                                                              _vm.selectAllUser,
                                                              null
                                                            ) > -1
                                                          : _vm.selectAllUser
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.selectAllUser,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.selectAllUser = $$a.concat(
                                                                  [$$v]
                                                                ))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.selectAllUser = $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                            }
                                                          } else {
                                                            _vm.selectAllUser = $$c
                                                          }
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "lbl"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ユーザーID")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ユーザー名")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ふりがな")]),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "center" }, [
                                          _vm._v("ステータス")
                                        ]),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "center" }, [
                                          _vm._v("開始日時")
                                        ]),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "center" }, [
                                          _vm._v("終了日時")
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.listUserGroup != null
                                      ? _c(
                                          "tbody",
                                          [
                                            _vm._l(_vm.listUserGroup, function(
                                              item,
                                              index
                                            ) {
                                              return [
                                                _c(
                                                  "tr",
                                                  {
                                                    key: index,
                                                    class: {
                                                      selected: _vm.rowSelected(
                                                        item.passageId
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "pos-rel"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.selectedUserId,
                                                                  expression:
                                                                    "selectedUserId"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "ace",
                                                              attrs: {
                                                                type: "checkbox"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.passageId,
                                                                checked: Array.isArray(
                                                                  _vm.selectedUserId
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.selectedUserId,
                                                                      item.passageId
                                                                    ) > -1
                                                                  : _vm.selectedUserId
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm.selectedUserId,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c = $$el.checked
                                                                      ? true
                                                                      : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v =
                                                                        item.passageId,
                                                                      $$i = _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        (_vm.selectedUserId = $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        (_vm.selectedUserId = $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                    }
                                                                  } else {
                                                                    _vm.selectedUserId = $$c
                                                                  }
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass: "lbl"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.userId.userId
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.userId.name)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.userId.furigana
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        item.userId.isValid
                                                          ? _c("span", [
                                                              _vm._v("有効")
                                                            ])
                                                          : _c("span", [
                                                              _vm._v("無効")
                                                            ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.converDate(
                                                              item.notBefore
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.converDate(
                                                              item.notAfter
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      : _c("tbody", [_vm._m(5)])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-cus btn-right btn-add",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.addUser(_vm.gateInfor.gateId)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    ユーザーの関連付けを追加\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn-cus btn-right btn-delete",
                                    attrs: {
                                      href: "#process",
                                      "data-toggle": "modal"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.resetStatus()
                                      }
                                    }
                                  },
                                  [_vm._v("チェックしたユーザーの関連付け解除")]
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "process", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v("このユーザーとの関連付けを解除しますか？")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress",
                  class: {
                    "progress-striped": !_vm.success,
                    active: !_vm.success,
                    hide: !_vm.success
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "progress-bar", style: _vm.progressWidth },
                    [
                      _c("span", [
                        _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.successUser > 0
                ? _c("span", { staticClass: "success-label" }, [
                    _vm._v(
                      _vm._s(_vm.countUser) +
                        "件中" +
                        _vm._s(_vm.successUser) +
                        "件を解除しました。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "error-box-title" }, [
                      _vm._v("解除失敗")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        click: function($event) {
                          _vm.deleteRelationUser()
                        }
                      }
                    },
                    [_vm._v("実行")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "processGate", tabindex: "-1" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v("このゲートとの関連付けを解除しますか？")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress",
                  class: {
                    "progress-striped": !_vm.success,
                    active: !_vm.success,
                    hide: !_vm.success
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "progress-bar", style: _vm.progressWidth },
                    [
                      _c("span", [
                        _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.successGate > 0
                ? _c("span", { staticClass: "success-label" }, [
                    _vm._v(
                      _vm._s(_vm.countGate) +
                        "件中" +
                        _vm._s(_vm.successGate) +
                        "件を解除しました。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "error-box-title" }, [
                      _vm._v("解除失敗")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        click: function($event) {
                          _vm.deleteRelationGate()
                        }
                      }
                    },
                    [_vm._v("実行")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("ダッシュボード")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [_c("h3", [_vm._v("ゲート編集")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [
        _c(
          "a",
          {
            staticClass: "accordion-toggle",
            attrs: { "data-toggle": "collapse", href: "#relation-gate" }
          },
          [
            _c("i", {
              staticClass: "bigger-110 ace-icon fa fa-angle-right",
              attrs: {
                "data-icon-hide": "ace-icon fa fa-angle-down",
                "data-icon-show": "ace-icon fa fa-angle-right"
              }
            }),
            _vm._v(
              "\n                       ゲートグループ\n                    "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "3" } }, [_vm._v("データーはありません")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [
        _c(
          "a",
          {
            staticClass: "accordion-toggle",
            attrs: {
              "data-toggle": "collapse",
              href: "#passage",
              "aria-expanded": "true"
            }
          },
          [
            _c("i", {
              staticClass: "ace-icon fa fa-angle-right bigger-110",
              attrs: {
                "data-icon-hide": "ace-icon fa fa-angle-down",
                "data-icon-show": "ace-icon fa fa-angle-right"
              }
            }),
            _vm._v(
              "\n                       期限付きゲートを持つユーザー\n                    "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "6" } }, [_vm._v("データーはありません")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("関連付け解除")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("関連付け解除")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-334eb22f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-334eb22f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/gate/GateEdit.vue
// module id = null
// module chunks = 